// // googleCalendarService.js
// import { gapi } from "gapi-script";

// const CLIENT_ID =
//   "720406794265-9k168n001an94iu4d1bv8dcohrtnqk87.apps.googleusercontent.com";
// const API_KEY = "AIzaSyB5eNJfinJmuvnAGbwf-R9-8DObA9HVI7k";
// const SCOPES = "https://www.googleapis.com/auth/calendar.events";

// export const initClient = () => {
//   return gapi.client.init({
//     apiKey: API_KEY,
//     clientId: CLIENT_ID,
//     discoveryDocs: [
//       "https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest",
//     ],
//     scope: SCOPES,
//   });
// };

// export const handleAuthClick = () => gapi.auth2.getAuthInstance().signIn();
// export const handleSignOutClick = () => gapi.auth2.getAuthInstance().signOut();

// export const listEvents = () =>
//   gapi.client.calendar.events.list({
//     calendarId: "primary",
//     timeMin: new Date().toISOString(),
//     showDeleted: false,
//     singleEvents: true,
//     maxResults: 10,
//     orderBy: "startTime",
//   });

// export const createEvent = (event) =>
//   gapi.client.calendar.events.insert({
//     calendarId: "primary",
//     resource: event,
//   });

// export const deleteEvent = (eventId) =>
//   gapi.client.calendar.events.delete({
//     calendarId: "primary",
//     eventId,
//   });

// googleCalendarService.js
import { gapi } from "gapi-script";

const CLIENT_ID =
  "720406794265-9k168n001an94iu4d1bv8dcohrtnqk87.apps.googleusercontent.com";
const API_KEY = "AIzaSyAJXbsL6UVwyKkGOl7MyDt4VZe6aBvWY3g";
const SCOPES = "https://www.googleapis.com/auth/calendar.events";

export const initClient = () => {
  return gapi.client.init({
    apiKey: API_KEY,
    clientId: CLIENT_ID,
    discoveryDocs: [
      "https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest",
    ],
    scope: SCOPES,
    redirect_uri: "http://localhost:3100/dashboard",
  });
};

export const checkLoginStatusAndInitialize = async () => {
  const authInstance = gapi.auth2.getAuthInstance();
  if (authInstance && authInstance.isSignedIn.get()) {
    return true;
  }
  await authInstance.signIn();
  return authInstance.isSignedIn.get();
};
console.log("redirectURI==>", window.location.href);

export const listEvents = () =>
  gapi.client.calendar.events.list({
    calendarId: "primary",
    timeMin: new Date().toISOString(),
    showDeleted: false,
    singleEvents: true,
    maxResults: 10,
    orderBy: "startTime",
  });

export const createEvent = (event) =>
  gapi.client.calendar.events.insert({
    calendarId: "primary",
    resource: event,
  });

export const deleteEvent = (eventId) =>
  gapi.client.calendar.events.delete({
    calendarId: "primary",
    eventId,
  });
